import l from "../../node_modules/classnames/index.js";
import { forwardRef as x } from "react";
import "../Blocks/Button/Button.js";
import { Emphasis as u } from "../Blocks/Emphasis/Emphasis.js";
import "../Blocks/Card/card2.js";
import { jsxs as i, jsx as e } from "../../_virtual/jsx-runtime.js";
import "../Blocks/Toaster/toast2.js";
import "../Blocks/Toaster/toaster2.js";
import "./UIInputCheckbox2.js";
const w = x(({
  hasError: o,
  name: c,
  className: a,
  disabled: r,
  onBlur: s,
  onChange: p,
  label: t,
  required: m,
  value: h,
  size: n = "medium"
}, d) => /* @__PURE__ */ i("label", {
  "data-error": o,
  "data-disabled": r,
  "data-size": n,
  className: l("input-checkbox shakeable", a),
  children: [/* @__PURE__ */ e("input", {
    ref: d,
    className: "input-checkbox__input",
    type: "checkbox",
    name: c,
    disabled: r,
    id: `checkbox_${c}`,
    checked: h === !0,
    onBlur: s,
    onChange: p
  }), /* @__PURE__ */ e("div", {
    className: "input-checkbox__square"
  }), t && /* @__PURE__ */ i("span", {
    className: "input-checkbox__text-label",
    children: [/* @__PURE__ */ e("span", {
      children: t
    }), m ? /* @__PURE__ */ e(u, {
      children: " *"
    }) : ""]
  })]
}));
export {
  w as UIInputCheckbox
};
//# sourceMappingURL=UIInputCheckbox.js.map
